module.exports = __webpack_public_path__ + "static/images/dkq.6ae5d9c2e.png";